import { render, staticRenderFns } from "./ContentPagePostItem.vue?vue&type=template&id=5f8989e6&scoped=true&"
import script from "./ContentPagePostItem.vue?vue&type=script&lang=js&"
export * from "./ContentPagePostItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentPagePostItem.vue?vue&type=style&index=0&id=5f8989e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8989e6",
  null
  
)

export default component.exports